(() => {
  'use strict';
  if (window.kanakaaZoomInstalled || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  window.kanakaaZoomInstalled = true;
  const icon = path => `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="${path}"/></svg>`;
  const dialog = document.createElement('dialog');
  dialog.className = 'product-zoom';
  dialog.setAttribute('aria-label', 'Product image viewer');
  dialog.innerHTML = `<div class="zoom-bar"><p data-zoom-counter role="status"></p><button class="icon-button" type="button" data-zoom-close aria-label="Close image viewer" autofocus>${icon('m6 6 12 12M6 18 18 6')}</button></div><div class="zoom-stage" tabindex="0" aria-label="Product image. Use plus and minus to zoom, arrow keys to move, and Escape to close."><img data-zoom-image alt="" draggable="false"><p class="zoom-error" role="alert" hidden>We couldn’t load this image. <a target="_blank" rel="noopener">Open original image</a></p></div><div class="zoom-controls"><button class="icon-button" type="button" data-zoom-prev aria-label="Previous image">${icon('m15 5-7 7 7 7')}</button><button class="icon-button" type="button" data-zoom-out aria-label="Zoom out">${icon('M5 12h14')}</button><output data-zoom-level aria-live="polite">100%</output><button class="icon-button" type="button" data-zoom-in aria-label="Zoom in">${icon('M5 12h14M12 5v14')}</button><button class="icon-button" type="button" data-zoom-next aria-label="Next image">${icon('m9 5 7 7-7 7')}</button></div><p class="zoom-help"></p>`;
  document.body.append(dialog);
  const stage = dialog.querySelector('.zoom-stage'), image = dialog.querySelector('[data-zoom-image]');
  const counter = dialog.querySelector('[data-zoom-counter]'), level = dialog.querySelector('[data-zoom-level]');
  const zoomIn = dialog.querySelector('[data-zoom-in]'), zoomOut = dialog.querySelector('[data-zoom-out]');
  const previous = dialog.querySelector('[data-zoom-prev]'), next = dialog.querySelector('[data-zoom-next]');
  const error = dialog.querySelector('.zoom-error'), points = new Map();
  let items = [], index = 0, opener, scale = 1, x = 0, y = 0, fitWidth = 0, fitHeight = 0, ready = false;
  let gesture, moved = false, lastTap, lastTouchAt = 0, savedScroll, savedStyle;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  function paint() {
    const limitX = Math.max(0, (fitWidth * scale - stage.clientWidth + 24) / 2);
    const limitY = Math.max(0, (fitHeight * scale - stage.clientHeight + 24) / 2);
    x = clamp(x, -limitX, limitX); y = clamp(y, -limitY, limitY);
    image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    dialog.dataset.zoom = scale.toFixed(2);
    stage.classList.toggle('is-zoomed', scale > 1);
    const text = `${Math.round(scale * 100)}%`;
    if (level.textContent !== text) level.textContent = text;
    zoomOut.disabled = !ready || scale <= 1;
    zoomIn.disabled = !ready || scale >= 4;
  }
  function fit() {
    if (!dialog.open || !ready || !stage.clientWidth || !image.naturalWidth) return;
    const ratio = Math.min((stage.clientWidth - 24) / image.naturalWidth, (stage.clientHeight - 24) / image.naturalHeight);
    fitWidth = image.naturalWidth * ratio; fitHeight = image.naturalHeight * ratio;
    Object.assign(image.style, {width:`${fitWidth}px`, height:`${fitHeight}px`, left:`${(stage.clientWidth - fitWidth) / 2}px`, top:`${(stage.clientHeight - fitHeight) / 2}px`});
    paint();
  }
  function zoom(value, clientX, clientY) {
    if (!ready) return;
    const rect = stage.getBoundingClientRect();
    const px = clientX === undefined ? 0 : clientX - rect.left - rect.width / 2;
    const py = clientY === undefined ? 0 : clientY - rect.top - rect.height / 2;
    const nextScale = clamp(value, 1, 4);
    x = px - (px - x) * nextScale / scale; y = py - (py - y) * nextScale / scale;
    scale = nextScale; paint();
  }
  function showImage(newIndex) {
    index = (newIndex + items.length) % items.length;
    scale = 1; x = 0; y = 0; ready = false; points.clear(); gesture = null; lastTap = null;
    stage.classList.remove('is-dragging'); error.hidden = true; image.hidden = true;
    counter.textContent = `Image ${index + 1} of ${items.length}`;
    previous.hidden = next.hidden = items.length < 2;
    image.alt = items[index].dataset.zoomAlt || '';
    error.querySelector('a').href = items[index].href;
    paint();
    image.src = items[index].href;
  }
  image.addEventListener('load', () => { ready = true; image.hidden = false; fit(); });
  image.addEventListener('error', () => { ready = false; image.hidden = true; error.hidden = false; paint(); });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-product-zoom]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    items = [...trigger.closest('.product-gallery').querySelectorAll('[data-product-zoom]')];
    opener = trigger;
    savedScroll = {x:window.scrollX, y:window.scrollY};
    savedStyle = Object.fromEntries(['position','top','left','width','overflow'].map(key => [key, document.body.style[key]]));
    Object.assign(document.body.style, {position:'fixed', top:`-${savedScroll.y}px`, left:`-${savedScroll.x}px`, width:'100%', overflow:'hidden'});
    dialog.querySelector('.zoom-help').textContent = matchMedia('(pointer: coarse)').matches ? 'Pinch or double-tap to zoom. Drag to explore.' : 'Double-click to zoom. Drag to explore.';
    dialog.showModal();
    showImage(items.indexOf(trigger));
    dialog.querySelector('[data-zoom-close]').focus();
  });
  function restorePage() {
    if (!savedStyle) return;
    points.clear(); gesture = null; lastTap = null;
    Object.assign(document.body.style, savedStyle);
    window.scrollTo({left:savedScroll.x, top:savedScroll.y, behavior:'instant'});
    savedStyle = null; savedScroll = null;
    opener?.isConnected && opener.focus({preventScroll:true});
  }
  function closeViewer() { dialog.close(); restorePage(); }
  dialog.querySelector('[data-zoom-close]').addEventListener('click', closeViewer);
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeViewer(); });
  dialog.addEventListener('close', () => { if (!dialog.open) restorePage(); });
  zoomIn.addEventListener('click', () => zoom(scale + .5));
  zoomOut.addEventListener('click', () => zoom(scale - .5));
  previous.addEventListener('click', () => showImage(index - 1));
  next.addEventListener('click', () => showImage(index + 1));
  stage.addEventListener('dblclick', event => { event.preventDefault(); if (event.sourceCapabilities?.firesTouchEvents || Date.now() - lastTouchAt < 700) return; zoom(scale > 1 ? 1 : 2.5, event.clientX, event.clientY); });
  function startGesture() {
    const values = [...points.values()];
    if (values.length >= 2) {
      const [a,b] = values, rect = stage.getBoundingClientRect();
      const mx = (a.x+b.x)/2 - rect.left - rect.width/2, my = (a.y+b.y)/2 - rect.top - rect.height/2;
      gesture = {distance:Math.max(1,Math.hypot(a.x-b.x,a.y-b.y)), scale, worldX:(mx-x)/scale, worldY:(my-y)/scale};
    } else if (values.length) gesture = {startX:values[0].x, startY:values[0].y, x, y};
    else gesture = null;
  }
  stage.addEventListener('pointerdown', event => {
    if (!ready || (event.pointerType === 'mouse' && event.button !== 0)) return;
    event.preventDefault();
    if (event.pointerType === 'touch') lastTouchAt = Date.now();
    points.set(event.pointerId,{x:event.clientX,y:event.clientY});
    if (points.size === 1) moved = false; else { moved = true; lastTap = null; }
    try { stage.setPointerCapture(event.pointerId); } catch (_) { /* Synthetic or cancelled pointer. */ }
    stage.classList.toggle('is-dragging', scale > 1); startGesture();
  });
  stage.addEventListener('pointermove', event => {
    if (!points.has(event.pointerId) || !gesture) return;
    points.set(event.pointerId,{x:event.clientX,y:event.clientY});
    const values = [...points.values()];
    if (values.length >= 2) {
      const [a,b] = values, rect = stage.getBoundingClientRect();
      scale = clamp(gesture.scale * Math.hypot(a.x-b.x,a.y-b.y) / gesture.distance, 1, 4);
      x = (a.x+b.x)/2 - rect.left - rect.width/2 - gesture.worldX*scale;
      y = (a.y+b.y)/2 - rect.top - rect.height/2 - gesture.worldY*scale;
      moved = true; paint();
    } else {
      const dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
      if (Math.hypot(dx,dy) > 6) moved = true;
      if (scale > 1) { x = gesture.x + dx; y = gesture.y + dy; paint(); }
    }
  });
  function release(event) {
    if (!points.has(event.pointerId)) return;
    if (event.type === 'pointerup' && points.size === 1 && !moved && event.pointerType === 'touch') {
      const now = Date.now();
      if (lastTap && now-lastTap.time < 320 && Math.hypot(event.clientX-lastTap.x,event.clientY-lastTap.y) < 30) {
        zoom(scale > 1 ? 1 : 2.5,event.clientX,event.clientY); lastTap = null;
      } else lastTap = {time:now,x:event.clientX,y:event.clientY};
    }
    points.delete(event.pointerId); startGesture();
    if (!points.size) stage.classList.remove('is-dragging');
  }
  stage.addEventListener('pointerup', release); stage.addEventListener('pointercancel', release); stage.addEventListener('lostpointercapture', release);
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('button, [tabindex="0"], a')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
      return;
    }
    if (['+','=','-','0','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) event.preventDefault();
    if (['+','='].includes(event.key)) zoom(scale+.5);
    else if (event.key === '-') zoom(scale-.5);
    else if (event.key === '0') zoom(1);
    else if (event.key.startsWith('Arrow')) {
      if (scale > 1) {x += event.key === 'ArrowLeft' ? 50 : event.key === 'ArrowRight' ? -50 : 0; y += event.key === 'ArrowUp' ? 50 : event.key === 'ArrowDown' ? -50 : 0;paint();}
      else if (items.length > 1 && ['ArrowLeft','ArrowRight'].includes(event.key)) showImage(index+(event.key==='ArrowLeft'?-1:1));
    }
  });
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(stage);
  window.addEventListener('resize', fit);
  document.addEventListener('shopify:section:unload', event => {if(dialog.open && event.target.contains(opener)) closeViewer();});
})();
